module.exports = require("core-js-pure/stable/reflect/construct");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/reflect/construct.js
// module id = 1704
// module chunks = 25